import photoConfig from 'ui-theme/widgets/axel-publication-content/js/config';

const config = photoConfig;
config.stickyHeader.breadcrumbs = false;

export default config;
